import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable()
export class RiskRecheckGuardService {
  protected readonly onDestroy$: Subject<void> = new Subject();

  constructor(
    private store: Store,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store
        .pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount))
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => {
          if (!value || !value.customer || !value.customer.email || !value.currentAccountDetail?.onboarding_step) {
            return;
          }

          if (value.currentAccountDetail?.risk_recheck_visible) {
            observer.next(true);
          } else {
            observer.next(this.router.parseUrl('/'));
          }
        });
    });
  }
}

export const RiskRecheckGuard: CanActivateFn = () => {
  return inject(RiskRecheckGuardService).canActivate();
};
